import React from "react";
import Svg, { ClipPath, Defs, G, Path, SvgProps } from "react-native-svg";

const CrossIcon = (props: SvgProps) => {
  return (
    <Svg fill="none" width="33" height="33" viewBox="0 0 35 35" {...props}>
      <G clipPath="url(#a)">
        <Path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.5 32.01a16 16 0 1 1 0-32 16 16 0 0 1 0 32Zm8-10.692a1.817 1.817 0 0 1 0 2.57l-.118.117a1.824 1.824 0 0 1-2.578 0l-4.674-4.67a.912.912 0 0 0-1.289 0L11.18 24a1.825 1.825 0 0 1-2.58 0l-.103-.102a1.818 1.818 0 0 1 .009-2.583l4.711-4.659a.906.906 0 0 0 0-1.295l-4.71-4.654a1.818 1.818 0 0 1-.01-2.583l.104-.103a1.82 1.82 0 0 1 1.29-.534c.503 0 1.735.98 2.065 1.31l3.885 3.886a.912.912 0 0 0 1.29 0l4.674-4.665a1.824 1.824 0 0 1 2.577 0l.118.122a1.818 1.818 0 0 1 0 2.57l-4.654 4.66a.906.906 0 0 0 0 1.283l4.654 4.665Z"
          fill="#CC293F"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" transform="translate(.5 .01)" d="M0 0h32v32H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default CrossIcon;
